import { Controller } from '@hotwired/stimulus';

export default class FiltersCloserController extends Controller {
  static targets = ['filter'];

  connect () {
    window.addEventListener('click', (event) => {
      if (event.target.name !== 'filters') {
        if (!event.target.closest('.selection__list')) {
          this.filterTargets.forEach((filter) => {
            filter.checked = false;
          });
        }
      }
    });
  }
}
